import Axios from "axios";
import config from "../app.config";

export var mailDraftService
export default mailDraftService = {
    getListMailDraft,
    deleteMailDraft,
    saveMailDraft,
}

// list function

async function getListMailDraft(data) {
    let mailBox = data.mailBox
    let queries = data.queries
    return await Axios.get(`${config.LOCAL_API_URL}/getListMailDraft/${mailBox}`, {params: queries})
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}

async function deleteMailDraft(data) {
    let mailBox = data['mailBox']
    return await Axios.delete(`${config.LOCAL_API_URL}/MailDraft/${mailBox}`,{data: data})
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}

async function saveMailDraft(mailData){
    return  Axios.post(`${config.LOCAL_API_URL}/saveMailDraft`, mailData, { headers: { 'canLoading': false } })
        .then(response =>{
            if(response.data.status && response.data){
                return Promise.resolve(response.data);
            }
            else{
                return Promise.resolve(response.data);
            }
        })
        .catch(error =>{
            return Promise.reject(error);
        })
}

